var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHealthiconsExercise(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 227,
    viewBox: "0 0 227 227",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    clipPath: "url(#clip0_179_6526)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.634 97.2633L166.614 104.18L132.03 164.08L120.05 157.163L135.613 130.208L87.6927 102.542L72.1302 129.497L60.1501 122.58L94.7335 62.68L106.713 69.5967L91.151 96.5517L139.071 124.218L154.634 97.2633ZM61.2009 79.2601L71.5759 61.29L83.556 68.2067L59.3476 110.137L47.3676 103.22L57.7426 85.2501L51.7526 81.7917L55.2109 75.8017L61.2009 79.2601ZM171.553 150.958L165.563 147.5L155.188 165.47L143.208 158.553L167.416 116.623L179.396 123.54L169.021 141.51L175.011 144.968L171.553 150.958Z",
    fill: "#E69A8D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_179_6526"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 166,
    height: 166,
    fill: "white",
    transform: "translate(83) rotate(30)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthiconsExercise);
export default __webpack_public_path__ + "static/media/healthicons_exercise.39fc129ee7f123d0cf369d693db4aef1.svg";
export { ForwardRef as ReactComponent };